/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { createSlice } from '@reduxjs/toolkit';
export const localizationSlice = createSlice({
    name: 'localizationData',
    initialState: { translations: undefined },
    reducers: {
        initializeTranslations: (state, action) => {
            state.translations = action.payload;
        }
    }
});
export const { initializeTranslations } = localizationSlice.actions;
export const { reducer } = localizationSlice;
//# sourceMappingURL=index.js.map